/* eslint-disable no-underscore-dangle */

/**
 * Class that handles auth initialisation.
 */
export default class AuthInitialiser {
  /**
   * Constructor.
   *
   * @param {Object} auth0Client
   * @param {Function} checkSession
   * @param {Function} loadAuth0User
   * @param {Function} loadUserData
   */
  constructor({ auth0Client, checkSession, loadAuth0User, loadUserData }) {
    this.auth0Client = auth0Client
    this.checkSession = checkSession
    this.loadAuth0User = loadAuth0User
    this.loadUserData = loadUserData
    this.getUserData = null
    this.error = null
    this.session = null
    this.authenticated = null
    this.userError = null
    this.user = null
    this.userDataError = null
    this.userData = null
  }

  /**
   * Runs the auth initialiser.
   *
   * @return {Promise}
   */
  async run() {
    const { error, session, authenticated } = await this.checkSession(this.auth0Client)

    this.error = error
    this.session = session
    this.authenticated = authenticated

    if (this.authenticated) {
      const { userError, user } = await this.loadAuth0User(this.auth0Client, session)

      this.userError = userError
      this.user = user

      if (!this.userError && this.user) {
        const { userDataError, userData } = await this.loadUserData(this.getUserData, user)

        this.userDataError = userDataError
        this.userData = userData
      }
    }

    return this
  }
}
